import React, { useCallback, useState } from 'react';
import { AccordionItem, Box, Inscription, LinkButton } from '@common-fe/common-fe';

import { ROUTES } from '@/common';

import { Renewal } from '../../renewals.types'; 
// import { useHandleExpressSetupSetUp } from '../../hooks';
import { SummaryBox } from '../styles/RenewalSetup.styles';

import { PlansSummaryContainer } from './PlansSummaryContainer';

interface Props {
  renewalSetupData?: Renewal;
}

const PlansSummary: React.FC<Props> = ({
  renewalSetupData,
}) => {
  const [isExpanded, setExpanded] = useState(false);
    const handleOpenPlans = useCallback(() => {
      window.open(
        `${ROUTES.PLANS}${window.location.search}`,
        '_blank'
      );
    }, []);

  return (
    <SummaryBox
      onClick={() => setExpanded(!isExpanded)}
      pad={{ vertical: 's', horizontal: 'm' }}
      border={{ color: 'border1', size: 'large' }}
      margin={{ bottom: 'l' }}
      round="container1Round"
      background={isExpanded ? 'border1' : 'canvas'}
    >
      <AccordionItem
        testId='plans-summary-item'
        iconSize='24px'
        isExpanded={isExpanded}
        text={(
          <Box
            background={isExpanded ? 'border1' : 'canvas'}
            margin={{ left: 'xxxs' }}
            direction="row"
            align="center"
          >
            <Inscription color="textBody" weight="normal" lineHeight='20px'>
              Summary of your current plans
            </Inscription>
          </Box>
        )}
        isLeftArrow
      >    
        <Box
          background="border1"
          margin={{ top: 's' }}
        >
          <PlansSummaryContainer
            planYear={renewalSetupData?.planYear}
            plans={renewalSetupData?.plans}
            isViewMode
          />
          <Box margin={{ top: 'xs'}}>
            <LinkButton onClick={handleOpenPlans} style={{ margin: 'xs' }} linkInlineMode>Open Plans</LinkButton>
          </Box>
        </Box>
      </AccordionItem>
    </SummaryBox>
  );
};

export default PlansSummary;
